(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-taxonomy-landing"]) return;
  try {
    
  document.querySelectorAll('[data-taxonomy-sort]').forEach((grid) => {
    [...grid.children]
      .sort((a, b) => Number(a.dataset.sortOrder || 9999) - Number(b.dataset.sortOrder || 9999))
      .forEach((item) => grid.appendChild(item));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-amazon-enhancement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const titleSeparator = /\s*[|｜]\s*/u;
    const normalizeText = (value) => value.replace(/\u00a0/gu, ' ').replace(/\s+/gu, ' ').trim();
    const normalizeHeading = (value) =>
      normalizeText(value).replace(/[：:。.!！?？]+$/gu, '').toLocaleLowerCase('en-US');

    function getDescriptionKeys(config) {
      const descriptionKeys = new Map();
      [
        ['highlights', config.dataset.highlightsAliases],
        ['directions', config.dataset.directionsAliases],
        ['information', config.dataset.informationAliases],
        ['disclaimer', config.dataset.disclaimerAliases]
      ].forEach(([role, aliases]) => {
        String(aliases || '')
          .split('|')
          .map(normalizeHeading)
          .filter(Boolean)
          .forEach((alias) => descriptionKeys.set(alias, role));
      });
      return descriptionKeys;
    }

    function parseProductTitle(rawTitle) {
      const normalized = normalizeText(rawTitle || '');
      const parts = normalized.split(titleSeparator).map(normalizeText).filter(Boolean);
      if (parts.length === 4) {
        return { primary: parts.slice(0, 2).join(' | '), benefit: parts[2], english: parts[3] };
      }
      if (parts.length >= 3) {
        return { primary: parts[0], benefit: parts.slice(1, -1).join(' | '), english: parts.at(-1) };
      }
      if (parts.length === 2) return { primary: parts[0], secondary: parts[1] };
      return { primary: normalized };
    }

    function renderProductTitle(element) {
      const rawTitle = element.dataset.rawTitle || element.textContent || '';
      const title = parseProductTitle(rawTitle);
      if (!title.primary) return;
      const fragment = document.createDocumentFragment();
      ['primary', 'benefit', 'english', 'secondary'].forEach((role) => {
        if (!title[role]) return;
        if (fragment.childNodes.length > 0) {
          const separator = document.createElement('span');
          separator.className = 'visually-hidden';
          separator.textContent = ' | ';
          fragment.append(separator);
        }
        const span = document.createElement('span');
        span.className = `product-amazon__title-${role}`;
        span.textContent = title[role];
        fragment.append(span);
      });
      element.replaceChildren(fragment);
    }

    function contentHasValue(fragment) {
      return normalizeText(fragment.textContent || '').length > 0 || Boolean(fragment.querySelector('img,video,table,ul,ol'));
    }

    function appendRangeContent(bucket, root, startNode, endNode) {
      const range = document.createRange();
      if (startNode) range.setStartAfter(startNode);
      else range.setStart(root, 0);
      if (endNode) range.setEndBefore(endNode);
      else range.setEnd(root, root.childNodes.length);
      const content = range.cloneContents();
      content.querySelectorAll('script,style,template').forEach((node) => node.remove());
      if (contentHasValue(content)) bucket.append(content);
    }

    function parseDescription(source, config) {
      const root = source.cloneNode(true);
      const descriptionKeys = getDescriptionKeys(config);
      const headings = Array.from(root.querySelectorAll('h2,h3,h4'))
        .map((node) => ({ node, key: descriptionKeys.get(normalizeHeading(node.textContent || '')) }))
        .filter((item) => item.key);
      if (headings.length === 0) return null;
      const buckets = {
        other: document.createDocumentFragment(),
        highlights: document.createDocumentFragment(),
        directions: document.createDocumentFragment(),
        information: document.createDocumentFragment(),
        disclaimer: document.createDocumentFragment()
      };
      appendRangeContent(buckets.other, root, null, headings[0].node);
      headings.forEach((item, index) => {
        appendRangeContent(buckets[item.key], root, item.node, headings[index + 1]?.node || null);
      });
      return buckets;
    }

    function mountDescription(config, source) {
      const parsed = parseDescription(source, config);
      if (!parsed) return false;
      const staged = [];
      Object.entries(parsed).forEach(([key, fragment]) => {
        if (!contentHasValue(fragment)) return;
        const slot = config.querySelector(`[data-description-slot="${key}"]`);
        const module = config.querySelector(`[data-amazon-module="${key}"]`);
        if (!slot || !module) return;
        staged.push({ key, slot, module, fragment });
      });
      if (staged.length === 0) return false;
      let hasDetails = false;
      staged.forEach(({ key, slot, module, fragment }) => {
        slot.replaceChildren(fragment);
        if (key === 'information') formatInformationSlot(slot, config);
        module.hidden = false;
        const nav = config.querySelector(`[data-amazon-nav="${key}"]`);
        if (nav) nav.hidden = false;
        hasDetails = true;
      });
      const details = config.querySelector('[data-amazon-details]');
      if (details && hasDetails) details.hidden = false;
      source.remove();
      return true;
    }

    function formatInformationSlot(slot, config) {
      const existingList = slot.querySelector('ul, ol');
      if (existingList) {
        let formattedRows = 0;
        existingList.querySelectorAll(':scope > li').forEach((item) => {
          if (item.querySelector('strong, span')) return;
          const match = normalizeText(item.textContent || '').match(/^([^:：]{1,24})\s*[:：]\s*(.+)$/u);
          if (!match) return;
          const term = document.createElement('strong');
          const description = document.createElement('span');
          term.textContent = normalizeText(match[1]);
          description.textContent = normalizeText(match[2]);
          item.replaceChildren(term, description);
          formattedRows += 1;
        });
        if (formattedRows > 0) existingList.classList.add('product-amazon__information-list');
        return;
      }
      if (slot.querySelector('table')) return;
      const text = normalizeText(slot.textContent || '');
      if (!text.includes('|') && !text.includes('｜')) return;
      const parts = text.split(/[|｜]/).map(normalizeText).filter(Boolean);
      if (parts.length < 2) return;
      const rows = [];
      let features = [];
      const featureLabel = config.dataset.featureLabel || '';
      const flushFeatures = () => {
        if (features.length === 0) return;
        rows.push({ label: featureLabel, value: features.join(' · ') });
        features = [];
      };
      parts.forEach((part) => {
        const match = part.match(/^([^:：]{1,24})\s*[:：]\s*(.+)$/);
        if (match) {
          flushFeatures();
          rows.push({ label: normalizeText(match[1]), value: normalizeText(match[2]) });
        } else {
          features.push(part);
        }
      });
      flushFeatures();
      if (rows.length < 2) return;
      const list = document.createElement('ul');
      rows.forEach(({ label, value }) => {
        const item = document.createElement('li');
        const term = document.createElement('strong');
        const description = document.createElement('span');
        term.textContent = label;
        description.textContent = value;
        item.append(term, description);
        list.append(item);
      });
      slot.replaceChildren(list);
    }

    function initializeDetailNavigation(config) {
      const desktop = window.matchMedia('(min-width: 750px)');
      const navItems = Array.from(config.querySelectorAll('[data-amazon-nav]:not([hidden])'));
      const panels = [
        ...config.querySelectorAll('[data-amazon-desktop-module]:not([hidden]), .product-amazon__detail-list details:not([hidden]):not([data-amazon-module="other"])')
      ];
      if (navItems.length === 0 || panels.length === 0) return;
      const panelKey = (panel) => panel.dataset.amazonDesktopModule || panel.dataset.amazonModule || panel.dataset.amazonScrollModule;
      const activate = (key) => {
        navItems.forEach((item) => {
          if (item.dataset.amazonNav === key) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      };
      let navigationLock = '';
      let navigationLockTimer;
      navItems.forEach((item) => {
        item.addEventListener('click', (event) => {
          if (!desktop.matches) return;
          const target = document.getElementById(item.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          navigationLock = item.dataset.amazonNav;
          window.clearTimeout(navigationLockTimer);
          activate(navigationLock);
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          navigationLockTimer = window.setTimeout(() => {
            navigationLock = '';
          }, 900);
        });
      });
      config.querySelectorAll('.product-amazon__detail-list details:not([hidden])').forEach((details) => {
        details.open = desktop.matches;
      });
      activate(panelKey(panels[0]));
      if (!desktop.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(
        (entries) => {
          if (navigationLock) return;
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) activate(panelKey(visible.target));
        },
        { rootMargin: '-18% 0px -62% 0px', threshold: [0, 0.05, 0.25] }
      );
      panels.forEach((panel) => observer.observe(panel));
    }

    function createBuyCard(productInfo, config, infoContainer) {
      const start = infoContainer.querySelector('[data-amazon-buy-start]');
      const end = infoContainer.querySelector('[data-amazon-buy-end]');
      if (!start || !end) return null;
      const aside = document.createElement('aside');
      aside.className = 'product-amazon__buy-card';
      aside.setAttribute('aria-label', productInfo.querySelector('.product__title h1')?.textContent || '');
      if (config.dataset.stickyBuyCard === 'true') aside.classList.add('is-sticky');
      let node = start.nextSibling;
      while (node && node !== end) {
        const next = node.nextSibling;
        aside.append(node);
        node = next;
      }
      start.remove();
      end.remove();
      infoContainer.parentElement.append(aside);
      return aside;
    }

    function synchronizePurchaseBreakdown(config, productInfo) {
      const buyCard = productInfo.querySelector('.product-amazon__buy-card');
      if (!buyCard || buyCard.querySelector('[data-amazon-purchase-breakdown]')) return;
      const quantityInput = buyCard.querySelector('.quantity__input');
      const priceRoot = buyCard.querySelector('[id^="price-"]');
      const currencyCode = config.dataset.currencyCode || 'USD';
      const isChinese = document.documentElement.lang.toLowerCase().startsWith('zh');
      const discountThreshold = Number(config.dataset.newCustomerDiscountThresholdCents || 3500);
      const discountRate = Number(config.dataset.newCustomerDiscountRate ?? 0.1);
      const customerEligibility = config.dataset.newCustomerEligible || 'unknown';
      const shippingThreshold = Number(config.dataset.freeShippingThresholdCents || 3900);
      const copy = JSON.parse(config.querySelector('[data-purchase-copy]').textContent);
      const quantityForm = buyCard.querySelector('.product-form__quantity');
      if (priceRoot && quantityForm) {
        const row = document.createElement('div');
        const priceGroup = document.createElement('div');
        const unitLabel = document.createElement('div');
        row.className = 'starside-price-quantity-row';
        unitLabel.className = 'form__label';
        unitLabel.textContent = copy.unit;
        priceRoot.before(row);
        priceGroup.append(unitLabel, priceRoot);
        row.append(priceGroup, quantityForm);
      }
      if (config.dataset.isB2b === 'true') return;
      const breakdown = document.createElement('section');
      const subtotalValue = document.createElement('span');
      const discountValue = document.createElement('span');
      const firstOrderValue = document.createElement('span');
      const totalValue = document.createElement('span');
      const note = document.createElement('div');
      breakdown.className = 'starside-purchase-breakdown';
      breakdown.dataset.amazonPurchaseBreakdown = '';
      breakdown.setAttribute('aria-live', 'polite');
      const createRow = (labelText, valueElement, modifier = '') => {
        const row = document.createElement('div');
        const label = document.createElement('span');
        row.className = `starside-purchase-breakdown__row${modifier}`;
        label.textContent = labelText;
        valueElement.className = 'starside-purchase-breakdown__value';
        row.append(label, valueElement);
        breakdown.append(row);
        return row;
      };
      createRow(copy.subtotal, subtotalValue);
      const discountRow = createRow(copy.actual_discount, discountValue, ' starside-purchase-breakdown__row--discount');
      const firstOrderRow = customerEligibility === 'true'
        ? createRow(copy.discount, firstOrderValue, ' starside-purchase-breakdown__row--discount')
        : null;
      const totalRow = createRow(copy.current_total, totalValue, ' starside-purchase-breakdown__row--total');
      note.className = 'starside-purchase-breakdown__note';
      breakdown.append(note);
      const form = buyCard.querySelector('.product-form');
      const formBlock = form?.parentElement;
      if (formBlock?.parentElement === buyCard) buyCard.insertBefore(breakdown, formBlock);
      else buyCard.append(breakdown);

      const formatMoney = (cents) => {
        const amount = Math.max(0, Number(cents) || 0) / 100;
        try {
          const locale = currencyCode === 'USD' ? 'en-US' : isChinese ? 'zh-CN' : 'en-US';
          const formatted = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(amount);
          return currencyCode === 'USD' && !formatted.includes('USD') ? `${formatted} USD` : formatted;
        } catch (_error) {
          return `${amount.toFixed(2)} ${currencyCode}`;
        }
      };
      const getUnitPriceCents = () => {
        const nativeTotal = buyCard.querySelector('product-quantity-total');
        let price = Number(nativeTotal?.dataset.unitPrice ?? config.dataset.unitPriceCents ?? 0);
        const quantity = Number(quantityInput?.value || 1);
        try {
          const breaks = JSON.parse(nativeTotal?.dataset.priceBreaks || '[]').sort((a,b) => b.minimum_quantity-a.minimum_quantity);
          const tier = breaks.find(t => quantity + Number(nativeTotal?.dataset.cartQuantity || 0) >= t.minimum_quantity);
          if (tier) price = Number(tier.price);
        } catch (_error) {}
        return Math.max(0, Math.round(price));
      };
      const getCompareAtPriceCents = () => {
        const nativeTotal = buyCard.querySelector('product-quantity-total');
        // A cleared variant compare-at price must not fall back to the previous variant.
        const value = nativeTotal ? nativeTotal.dataset.compareAtPrice : config.dataset.compareAtPriceCents;
        return Math.max(0, Math.round(Number(value) || 0));
      };
      let previousKey = '';
      const update = () => {
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
        const unitPrice = getUnitPriceCents();
        const subtotal = Math.max(0, unitPrice * quantity);
        const merchandiseTotal = Math.max(unitPrice, getCompareAtPriceCents()) * quantity;
        const saleDiscount = merchandiseTotal - subtotal;
        // Unknown visitors are not assumed to be first-time customers.
        const firstOrderDiscount = currencyCode === 'USD' && customerEligibility === 'true' && subtotal >= discountThreshold
          ? Math.round(subtotal * discountRate) : 0;
        const payable = Math.max(0, subtotal - firstOrderDiscount);
        const key = [merchandiseTotal, saleDiscount, firstOrderDiscount, payable].join(':');
        if (key === previousKey) return;
        previousKey = key;
        subtotalValue.textContent = formatMoney(merchandiseTotal);
        discountRow.hidden = saleDiscount <= 0;
        discountValue.textContent = saleDiscount ? '-' + formatMoney(saleDiscount) : '';
        if (firstOrderRow) firstOrderRow.hidden = firstOrderDiscount <= 0;
        firstOrderValue.textContent = firstOrderDiscount ? '-' + formatMoney(firstOrderDiscount) : '';
        totalRow.firstElementChild.textContent = firstOrderDiscount ? copy.total : copy.current_total;
        totalValue.textContent = formatMoney(payable);
        const paragraphs = [];
        if (customerEligibility === 'true' && currencyCode === 'USD' && discountRate > 0) {
          paragraphs.push(copy.eligible);
        }
        paragraphs.push(copy.shipping);
        if (currencyCode === 'USD') paragraphs.push(payable >= shippingThreshold ? copy.unlocked : copy.remaining.replace('__AMOUNT__', formatMoney(shippingThreshold-payable)));
        paragraphs.push(copy.exclusions);
        note.replaceChildren(...paragraphs.map(text => { const p=document.createElement('p'); p.textContent=text; return p; }));

      };
      quantityInput?.addEventListener('input', update);
      quantityInput?.addEventListener('change', update);
      const observer = new MutationObserver(update);
      observer.observe(buyCard, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['value', 'data-unit-price', 'data-compare-at-price', 'data-price-breaks', 'data-cart-quantity', 'data-selected-variant', 'class', 'aria-disabled']
      });
      update();
    }

    function synchronizeMobileBar(config, productInfo) {
      const bar = config.querySelector('[data-amazon-mobile-bar]');
      const proxyButton = config.querySelector('[data-amazon-mobile-submit]');
      if (!bar || !proxyButton) return;
      const quantityInput = productInfo.querySelector('.quantity__input');
      const getUnitPriceCents = () => {
        const variantJson = productInfo.querySelector('variant-selects [data-selected-variant]');
        if (variantJson) {
          try {
            const variant = JSON.parse(variantJson.textContent || '{}');
            if (Number.isFinite(Number(variant.price))) return Number(variant.price);
          } catch (_error) {
            // Keep the Liquid-rendered price as a safe fallback while variants update.
          }
        }
        return Number(config.dataset.unitPriceCents || 0);
      };
      const formatTotalPrice = (sourceText, unitPriceCents, quantity) => {
        if (!sourceText || !unitPriceCents || quantity <= 1) return sourceText;
        const numberMatch = sourceText.match(/\d[\d\s.,]*/u);
        if (!numberMatch) return sourceText;
        const sourceNumber = numberMatch[0].trim();
        const decimalMatch = sourceNumber.match(/[.,](\d{1,3})$/u);
        const fractionDigits = decimalMatch ? decimalMatch[1].length : unitPriceCents % 100 === 0 ? 0 : 2;
        const formattedNumber = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits
        }).format((unitPriceCents * quantity) / 100);
        return sourceText.replace(sourceNumber, formattedNumber);
      };
      const update = () => {
        const sourcePrice = productInfo.querySelector('[id^="price-"] .price__container');
        const sourceButton = productInfo.querySelector('.product-form__submit');
        if (!sourceButton) {
          bar.hidden = true;
          return;
        }
        const price = config.querySelector('[data-amazon-mobile-price]');
        const visiblePrices = sourcePrice
          ? Array.from(sourcePrice.querySelectorAll('.price-item')).filter(
              (item) => item.getClientRects().length > 0 && normalizeText(item.textContent || '')
            )
          : [];
        const sourcePriceText = normalizeText(visiblePrices.at(-1)?.textContent || sourcePrice?.textContent || '');
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
        if (price) price.textContent = formatTotalPrice(sourcePriceText, getUnitPriceCents(), quantity);
        proxyButton.textContent = normalizeText(sourceButton.textContent || '');
        proxyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
        bar.hidden = false;
        document.documentElement.classList.add('has-product-amazon-bar');
      };
      proxyButton.addEventListener('click', () => {
        const sourceButton = productInfo.querySelector('.product-form__submit');
        if (sourceButton && !sourceButton.disabled) sourceButton.click();
      });
      quantityInput?.addEventListener('input', update);
      quantityInput?.addEventListener('change', update);
      const observer = new MutationObserver(update);
      observer.observe(productInfo, { subtree: true, childList: true, characterData: true, attributes: true });
      update();
    }

    function initializeConfig(config) {
      if (config.dataset.initialized === 'true') return;
      const productInfo = document.querySelector(`product-info[data-product-id="${config.dataset.productId}"]`);
      if (!productInfo) return;
      const infoContainer = productInfo.querySelector('.product__info-container');
      const infoWrapper = productInfo.querySelector('.product__info-wrapper');
      const title = productInfo.querySelector('.product__title h1');
      if (!infoContainer || !infoWrapper || !title) return;
      config.dataset.initialized = 'true';
      productInfo.classList.add('product-amazon');
      title.dataset.rawTitle = title.dataset.rawTitle || title.textContent || '';
      title.dataset.productTitle = '';
      renderProductTitle(title);
      if (!productInfo.querySelector('.product-amazon__buy-card')) createBuyCard(productInfo, config, infoContainer);
      let source = infoContainer.querySelector('.product__description');
      let cache = productInfo.querySelector('template[data-product-description-cache]');
      if (source && !cache) {
        cache = document.createElement('template');
        cache.dataset.productDescriptionCache = '';
        cache.content.append(source.cloneNode(true));
        productInfo.append(cache);
      }
      if (!source && cache) source = cache.content.querySelector('.product__description')?.cloneNode(true);
      if (source) {
        source.dataset.productDescriptionSource = '';
        const ratingBlock = infoContainer.querySelector('.shopify-app-block:has(.jdgm-preview-badge)');
        (ratingBlock || title.closest('.product__title'))?.after(source);
      }
      synchronizePurchaseBreakdown(config, productInfo);
      const highlights = config.querySelector('[data-amazon-module="highlights"]');
      const previousHighlights = infoWrapper.querySelector(':scope > [data-amazon-module="highlights"]');
      if (previousHighlights && previousHighlights !== highlights) previousHighlights.remove();
      if (highlights) infoWrapper.append(highlights);
      initializeDetailNavigation(config);
      synchronizeMobileBar(config, productInfo);
      productInfo.classList.remove('product-amazon--pending');
      productInfo.classList.add('product-amazon--ready');
    }

    function initializeProductAmazon(root = document) {
      root.querySelectorAll('[data-product-amazon-config]').forEach(initializeConfig);
    }

    initializeProductAmazon();
    document.addEventListener('shopify:section:load', (event) => initializeProductAmazon(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starside-about"] && !Shopify.designMode) return;
  try {
    
  const initializeStarsideTV = (root) => {
    root.querySelectorAll('[data-starside-tv]').forEach((player) => {
      if (player.dataset.ready) return;
      player.dataset.ready = 'true';
      const video = player.querySelector('video');
      const parts = Array.from(player.querySelectorAll('[data-tv-part]'));
      if (!video || !parts.length) return;
      let current = 0;
      const selectPart = (index, play) => {
        current = index;
        video.src = parts[index].dataset.tvPart;
        video.load();
        parts.forEach((button, number) => button.setAttribute('aria-pressed', String(number === index)));
        if (play) video.play().catch(() => {});
      };
      parts.forEach((button, index) => button.addEventListener('click', () => selectPart(index, true)));
      video.addEventListener('ended', () => { if (current + 1 < parts.length) selectPart(current + 1, true); });
    });
  };
  initializeStarsideTV(document);
  document.addEventListener('shopify:section:load', (event) => initializeStarsideTV(event.target));

  } catch(e) { console.error(e); }
})();
})();
